interface Props {
    title: string;
    value: string;
    icon: React.ReactElement;
}

const TaskItem: React.FC<Props> = ({ title, value, icon }) => {
    return (
        <div className='flex items-center py-4'>
            <div className='flex w-1/2 items-center gap-2 text-sm text-gray-600'>
                {icon}
                <span>{title}</span>
            </div>
            <span className='w-1/2 text-right text-sm font-semibold text-gray-900'>{value}</span>
        </div>
    );
};

export default TaskItem;

